<template>
  <div class="quality quality-submit">
    <z-form label-width="100px" @submit="onSubmit" @failed="onFailed">
      <z-field
        v-model="bizName"
        name="bizName"
        label="企业名称"
        label-width="100px"
        placeholder="请输入认证企业名称"
      />

      <z-field
        v-model="creditCode"
        name="creditCode"
        label="社会信用代码"
        label-width="100px"
        placeholder="请输入认证企业社会信用代码"
      />

      <section class="upload-area">
        <evidence-upload-item class="evidence" type="front" tip="点击上传彩色原件或加盖公司公章的复印件" @uploaded="UploadedEvi">
          <div class="sample-cover"></div>
        </evidence-upload-item>
      </section>

      <z-field
        v-model="name"
        name="name"
        label="法定代表人"
        label-width="100px"
        placeholder="请输入法定代表人"
      />

      <z-field
        v-model="idCard"
        name="idCard"
        label="身份证号"
        label-width="100px"
        placeholder="请输入身份证号"
      />

      <!-- <section class="quality-idcard">
        <div class="quality-idcard-upload">
          <capture-upload
            order="1"
            @uploaded="UploadedPic"
            img="n_v2c26867e9206f44009400ddde871a2593.png"
          />
          <capture-upload
            order="2"
            @uploaded="UploadedPic"
            img="n_v27754addf40324bd08c077a4ce8bbb045.png"
          />
        </div>
      </section> -->

      <section class="upload-area">
        <media-upload-item class="id-card front" type="front" @uploaded="frontPicUploaded">
          <div class="sample-cover"></div>
        </media-upload-item>
        <media-upload-item class="id-card back" type="back" @uploaded="backPicUploaded">
          <div class="sample-cover"></div>
        </media-upload-item>
        <div style="clear: both; width: 100%;"></div>
      </section>

      <z-button-group>
        <z-button type="primary" btn-class="bottombtn" loading-text="提交中..." native-type="submit" :disabled="disabled" :loading="btnLoading" :text="btnText"></z-button>
      </z-button-group>
    </z-form>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Field, Button, ButtonGroup, Toast, Form } from '@zz-common/zz-ui'
import MediaUploadItem from '../../RealAuth/MediaUploadItem/MediaUploadItem';
import EvidenceUploadItem from '../../cloudInspection/MediaUploadItem/MediaUploadItem';

export default {
  name: 'QuaForm',
  data() {
    return {
      creditCode: '', //统一社会信用代码
      bizName: '', //企业名称
      bizPic: '', //
      name: '', //姓名
      idCard: '', //身份证号
      picFront: '', //身份证照片人像面
      picBack: '' //身份证照片国徽面
    }
  },
  props: {
    btnLoading: {
      type: Boolean,
      default: false
    },
    btnText: {
      type: String,
      default: '下一步'
    }
  },
  computed: {
    disabled() {
      return (
        this.creditCode === '' ||
        this.bizName === '' ||
        this.bizPic === '' ||
        this.name === '' ||
        this.idCard === '' ||
        this.picFront === '' ||
        this.picBack === ''
      )
    }
  },
  components: {
    zButtonGroup: ButtonGroup,
    zButton: Button,
    zField: Field,
    zForm: Form,
    MediaUploadItem,
    EvidenceUploadItem
  },
  methods: {
    onSubmit(values) {
      const params = {
        ...values,
        bizPic: this.bizPic,
        picFront: this.picFront,
        picBack: this.picBack
      }
      if (this.disabled) return Toast('请填写所有内容再提交')
      this.$emit('handleSubmit', params)
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
      Toast('failed');
    },
    UploadedPic(rst, startTime, order) {
      if (order === '1') this.picFront = rst
      if (order === '2') this.picBack = rst
    },
    frontPicUploaded(rst) {
      this.picFront = rst
    },
    backPicUploaded(rst) {
      this.picBack = rst
    },
    UploadedEvi(rst) {
      this.bizPic = rst
    }
  },
  mounted() {
    console.log('mounted');
    native.setTitle({
      title: '资质提交'
    })
    console.log('setTitle');
  }
}
</script>

<style lang="less">
  @import 'index.less';
</style>
